'use strict';

const jQuery = require('jquery');
const _ = require('lodash');

const zone = require('./../../../services/structure/zone');
const translator = require('./../../../core/translator');
const mediator = require('./../../../core/mediator');
const container = require('./../../../core/container');
const pageRepository = require('./../repository/page');
const FormBuilder = require('./../../../services/form');
const Loader = require('./../../../services/loader');
const Notifier = require('./../../../services/notifier');
const flashMessage = require('./../../../services/flashMessage');
const Help = require('./../../../services/help');
const helper = require('./../../../services/helper');

const LangRepository = require('./../../user/repository/LangRepository');

const btnLayoutTpl = require('./../templates/new_page_button.hbs');

const HEADER_PAGE_URL = 'X-Page-URL';

const onSubmit = function(type, page) {
  let dfd = jQuery.Deferred();

  _.each(page, function(value, key) {
    if (-1 !== key.indexOf('seo_')) {
      page.seo = page.seo || {};
      page.seo[key.replace('seo_', '')] = value;
      delete page[key];
    } else {
      page[key] = value;
    }
  });

  page.type = type;

  Loader.start(container.get('$smallPanel'));
  pageRepository[type === 'duplicate' ? 'duplicate' : 'save'](page).done(function(data, response) {
    Loader.stop(container.get('$smallPanel'));

    const pageUrl = response.getHeader(HEADER_PAGE_URL) || response.getHeader(HEADER_PAGE_URL.toLowerCase());

    flashMessage.add(translator.translate(type === 'duplicate' ? 'duplicate_done' : 'page_created'), 'success');
    zone.hidePanels(container.get('$smallPanel'));

    window.location.replace(pageUrl);

    dfd.resolve(data, response);
  }).fail(function(data, response) {
    Notifier.warning(translator.translate('error'));
    dfd.reject(data, response);
  });
};

const onValidate = function(data, form) {
  if (data.title.length < 2) {
    form.addError('title', translator.translate('new_page_title_error'));
  }
  if (data.title && helper.isValidTitle(data.title)) {
    form.addError('title', translator.translate('error_title_page'));
  }
};

const addLayer = function(type, tags = [], langs = [], titleParam = '', descriptionParam = '') {
  let $container = jQuery('<div />');
  let $layer;

  pageRepository.getAuthorizedCategories(type).done((pageCategories) => {
    let formConfig = {
      'elements': {},
      'form': {
        'submit_class': 'd-none',
      },
    };

    let langOptions = {};
    let selectedLang = '';

    _.forEach(langs, function(lang) {
      if (lang['is_active']) {
        langOptions[lang.id] = lang.label;

        if (lang.id === jQuery('html').attr('lang') || lang['is_default'] && selectedLang === '') {
          selectedLang = lang.id;
        }
      }
    });

    if (_.find(langs, {'is_active': true})) {
      formConfig.elements.lang = {
        'type': 'select',
        'value': selectedLang,
        'label': translator.translate('new_page_lang'),
        'options': langOptions,
      };
    }

    formConfig.elements['title'] = {
      'type': 'text',
      'label': translator.translate('page_parameters_form_title'),
      'value': titleParam,
    };

    formConfig.elements['tags'] = {
      'type': 'selectTag',
      'label': translator.translate('page_parameters_form_tags'),
      'value': tags,
    };

    if (type === 'duplicate') {
      formConfig.elements['seo_description'] = {
        'type': 'textarea',
        'label': translator.translate('seo_description'),
        'value': descriptionParam,
      };
    }

    if (pageCategories.length) {
      formConfig.elements['category'] = {
        'type': 'select',
        'label': 'group_management_page_categories',
        'defaultOption': translator.translate('choose_category'),
        'options': function() {
          return pageCategories.reduce((options, category) => {
            options[category] = translator.translate(`page_category_${category}`);
            return options;
          }, {});
        }(),
        'value': '',
      };
    }

    mediator.publish('before:render:form-new-page', {
      formConfig,
      pageData: {type},
    });

    let form = FormBuilder.getForm(formConfig);

    form.on('submit', onSubmit.bind(undefined, type));
    form.on('validate', onValidate);

    $container.append(form.render());

    if (selectedLang) {
      let $lang = form.$.find('.element_lang');
      let $link = jQuery(`<a class="setting-link" href="#">${translator.translate('manage_languages')}</a>`);

      $link.on('click', function(e) {
        e.preventDefault();

        mediator.publish('menu:more-parameters:lang_management:click', {
          'onSubmit': function() {
            localStorage.setItem('newpageType', type);
            flashMessage.addCallback('menu:new-page:click', true);
          },
        });
      });

      $lang.append($link);
    }

    let $autocompleteInput = form.$.find('.element_tags').find('input');
    $layer.on('click', function(e) {
      let $target = jQuery(e.target);

      if (!$target.is($autocompleteInput)) {
        if ($target.hasClass('autocomplete-search')) {
          $autocompleteInput.autocomplete('search', $autocompleteInput.val());
        } else {
          $autocompleteInput.val('');
          if ($autocompleteInput.hasClass('ui-autocomplete-input')) {
            $autocompleteInput.autocomplete('close');
          }
        }
      }
    });

    zone.setFooter($layer, zone.createSubmitButtons({
      onSubmitClick: form.submit.bind(form),
    }));
  });

  let title = translator.translate(`page_type_${type}`) === `page_type_${type}` ? `new_page_${type}` : `page_type_${type}`;

  $layer = zone.addLayer(translator.translate(title), $container);
};

const onItemClick = function(currentType, page, langs) {
  addLayer(currentType, [], langs);

  return false;
};

const onClickDuplicate = function(currentType, page, langs) {
  addLayer(currentType, page.tags, langs, page.title, page.seo.description);

  return false;
};

module.exports.init = function() {
  let $panel = jQuery('<ul class="cloud-list new-page-list list-unstyled"></ul>');
  let $btnDuplicate = jQuery(`<ul class="cloud-list list-unstyled"><li><button class="btn btn-default btn-block btn-duplicate">${translator.translate('new_page_duplicate')}</button></li></ul>`);
  let $modelTitle = jQuery(`<div><div class="cloud-liner"></div><p class="text-uppercase mb-3"><small><b>${translator.translate('new_page_choose_model')}</b></small></p></div>`);

  let getCurrentPage = function() {
    let dfd = jQuery.Deferred();

    pageRepository.find(container.get('page.uid')).done(function(page) {
      dfd.resolve(page);
    }).fail(function() {
      dfd.resolve(null);
    });

    return dfd.promise();
  };

  let $smallPanel = zone.setSmallPanel(translator.translate('new_page'), $panel, true, {
    'extraTitle': Help.createLink('add_page'),
  });

  Loader.start($smallPanel);

  getCurrentPage().done(function(page) {
    pageRepository.getTypes('create').done(function(types) {
      LangRepository.findAll('new_page').done(function(langs) {
        if (page !== null && page.type_data && page.type_data.is_duplicable && container.get('isAllowedTo')('DUPLICATE_PAGE')) {
          $panel.before($btnDuplicate);
          $btnDuplicate.after($modelTitle);
        }

        types = types.filter((element) => {
          return !element.is_protected;
        });

        $btnDuplicate.on('click', function() {
          onClickDuplicate('duplicate', page, langs);

          return false;
        });

        _.each(types, function(type) {
          let label = translator.translate(`page_type_${type.unique_name}`) === `page_type_${type.unique_name}` ? `new_page_${type.unique_name}` : `page_type_${type.unique_name}`;

          type.ico = type.unique_name;
          type.name = translator.translate(label);

          let $item = jQuery('<li>' + btnLayoutTpl(type) + '</li>');

          $item.on('click', function() {
            let currentType = jQuery(this).find('.new-page-wrapper:first').data('name');

            onItemClick(currentType, page, langs);
          });

          $panel.append($item);

          Loader.stop($smallPanel);
        });

        if (localStorage.getItem('newpageType')) {
          let currentType = localStorage.getItem('newpageType');

          onItemClick(currentType, page, langs);
        }
        localStorage.removeItem('newpageType');
      });
    });
  });
};
